import { MRT_RowVirtualizer } from 'material-react-table';
import { useCallback, useEffect, useRef, useState } from 'react';
import { SearchResults } from 'types/Search';

const useTableScroll = (
  loading: boolean,
  searchResults: SearchResults,
  onLoadMore: () => void
) => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const rowVirtualizerInstanceRef = useRef<MRT_RowVirtualizer>(null);
  const handleScrollToTop = () => {
    rowVirtualizerInstanceRef.current?.scrollToIndex(0);
  };
  useEffect(() => {
    // scroll to top of table when filters change
    handleScrollToTop();
  }, []);

  const onScroll = useCallback(
    (containerRefElement?: HTMLDivElement | null) => {
      if (containerRefElement) {
        const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
        //show hide button
        if (scrollTop > 200 && !showBackToTop) {
          setShowBackToTop(true);
        } else if (scrollTop <= 200 && showBackToTop) {
          setShowBackToTop(false);
        }
        //fetch more on bottom reached
        if (
          scrollHeight - scrollTop - clientHeight < 5 &&
          !loading &&
          searchResults.results.length < searchResults.total
        ) {
          onLoadMore();
        }
      }
    },
    [
      showBackToTop,
      loading,
      searchResults.results.length,
      searchResults.total,
      onLoadMore
    ]
  );
  return {
    handleScrollToTop,
    onScroll,
    showBackToTop,
    rowVirtualizerInstanceRef
  };
};

export default useTableScroll;
